export default __webpack_public_path__ + "static/carousel-6-68cdb5aa0ebf02476bbb58057ce45892.jpg";